import { Component, OnInit } from "@angular/core";

@Component({
    selector: "bas-account-lock",
    templateUrl: "./account-lock.component.html",
    styleUrls: ["./account-lock.component.scss"],
    standalone: false
})
export class AccountLockComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
